<app-landing-popup *ngIf="showPopup" (closePopup)="onClosePopup()"></app-landing-popup>

<!-- Section 1 -->
<div class="section-1">
    <img src="/assets/images/HPsection1.jpg" class="desktop-bg-image" alt="background">

    <div class="home-actions-container">
        <!-- Button -->
        <button class="login-button" (click)="navigateToEko()">
            {{'sec1_button_1' | translate}}
        </button>
        <!-- EOL OF LOGIN -->
        <!-- <button class="login-button" *ngIf="!loggedIn" (click)="openLoginDialog()">
            {{'gen_login' | translate}}
        </button> -->
    </div>
</div>